/**
 * CodeMirror widgets for rendering chips and tokens
 */

import {WidgetType} from "@codemirror/view";

/**
 * Widget for rendering ingredient chips
 */
export class IngredientChipWidget extends WidgetType {
  constructor(private label: string) {
    super();
  }

  toDOM(): HTMLElement {
    const span = document.createElement("span");
    span.className = "chip chip-ingredient";
    span.textContent = this.label;
    span.setAttribute("contenteditable", "false");
    return span;
  }

  eq(other: IngredientChipWidget): boolean {
    return this.label === other.label;
  }

  updateDOM(): boolean {
    return false;
  }

  ignoreEvent(): boolean {
    return false;
  }
}
